import type { RoundPhase } from '@shared-types/match.types';
import type { GroupStanding } from '@shared-types/standing.types';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, domesticApiUrl, standingsApiUrl } from '@utilities/WindowContext';

export const fetchStandings = (
  params: {
    competitionId?: string;
    seasonYear?: string;
    phase?: RoundPhase;
    groupIds?: string | number | string[] | number[];
    roundId?: string | number;
    isDomestic?: boolean;
  },
  signal?: AbortSignal,
) => {
  const { competitionId, seasonYear, phase, groupIds, roundId, isDomestic } = params;
  let filters: Record<string, any> = { competitionId, seasonYear, phase };
  if (groupIds) {
    filters = { groupIds };
  } else if (roundId) {
    filters = { roundId };
  }
  const baseUrl = isDomestic ? domesticApiUrl : standingsApiUrl;
  const path = isDomestic ? 'v2/standings' : 'v1/standings';
  return loadFromAPIs<GroupStanding[]>(path, filters, { apiUrl: baseUrl, apiKey, signal });
};
